import { API_ROUTES } from '@/constants/apiRoutes';
import { IdempotentRequest } from '@/types/common';
import {
  AddWireRecipientForm,
  RecipientDetail,
  RecipientPreviewListResponse,
  RecipientRequestDetail,
  RecipientRequestPreviewListResponse,
} from '@/types/wireRecipients';
import { api } from '@/utils/api';

export const getWireRecipientListService = async (queryParams: string) => {
  const { data } = await api<RecipientPreviewListResponse>({
    url: `${API_ROUTES.WIRE_RECIPIENTS}/?${queryParams}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const getWireRecipientRequestListService = async (
  queryParams: string,
) => {
  const { data } = await api<RecipientRequestPreviewListResponse>({
    url: `${API_ROUTES.WIRE_RECIPIENTS}/requests?${queryParams}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const addWireRecipientService = async (
  payload: IdempotentRequest<AddWireRecipientForm>,
) => {
  const { customerId, bankInfo, recipientInfo } = payload;
  const { status } = await api({
    url: `${API_ROUTES.WIRE_RECIPIENTS}/request`,
    method: 'post',
    data: {
      consumer_id: customerId,
      recipient_nick_name: recipientInfo.nickName,
      account_name: recipientInfo.name,
      account_type: bankInfo.accountType,
      account_number: bankInfo.accountNumber,
      routing_number: bankInfo.routingNumber,
      bank_name: bankInfo.bankName,
      bank_address_line_1: bankInfo.line1,
      bank_address_line_2: bankInfo.line2,
      bank_address_city: bankInfo.city,
      bank_address_state: bankInfo.state,
      bank_address_postal_code: bankInfo.zip,
      bank_address_country_code: bankInfo.country,
      current_address_line_1: recipientInfo.line1,
      current_address_line_2: recipientInfo.line2,
      current_address_city: recipientInfo.city,
      current_address_state: recipientInfo.state,
      current_address_postal_code: recipientInfo.zip,
      current_address_country_code: recipientInfo.country,
    },
    idempotencyKey: payload.idempotencyKey,
    version: 2,
  });

  return status;
};

export const getWireRecipientDetailsService = async (uuid: string) => {
  const { data } = await api<RecipientDetail>({
    url: `${API_ROUTES.WIRE_RECIPIENTS}/${uuid}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const getWireRecipientRequestDetailsService = async (uuid: string) => {
  const { data } = await api<RecipientRequestDetail>({
    url: `${API_ROUTES.WIRE_RECIPIENTS}/requests/${uuid}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const cancelWireRecipientRequestService = async (uuid: string) => {
  const { status } = await api({
    url: `${API_ROUTES.WIRE_RECIPIENTS}/requests/${uuid}/cancel`,
    method: 'post',
    version: 2,
  });

  return status;
};

export const deleteWireRecipientRequestService = async (uuid: string) => {
  const { status } = await api({
    url: `${API_ROUTES.WIRE_RECIPIENTS}/${uuid}`,
    method: 'delete',
    version: 2,
  });

  return status;
};
